import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { loginSuccess } from './../../store/slices/authSlice';
import { loadPersistedAuth, persistAuth, getPersistedSessionId } from './../../utils/auth';
import api from './../../utils/api';

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [gateOpen, setGateOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        // 1) Rehydrate from persisted auth (survives browser close)
        const cached = loadPersistedAuth();
        if (cached?.user && cached?.token) {
          sessionStorage.setItem('userId', cached?.user?._id || cached?.user?.id);
          dispatch(loginSuccess(cached));
          setGateOpen(true);
          setIsChecking(false);
          return;
        }

        // 2) Fallback: validate by sessionId (DB session)
        const sessionId = getPersistedSessionId();
        const lastRoomId = sessionStorage.getItem('lastRoomId');
        if (sessionId) {
          const res = await api.post('/auth/session-validate', { sessionId });
          dispatch(loginSuccess(res.data));
          persistAuth(res.data, true);
          setGateOpen(true);

          if (lastRoomId && !location.pathname.includes('/room/')) {
            try {
              const roomRes = await api.get(`/rooms/${lastRoomId}`);
              if (roomRes.data?.isActive) {
                // navigate by rendering Navigate
                return;
              }
            } catch {}
          }
        } else {
          setGateOpen(false);
        }
      } catch (err) {
        console.warn('Session validation failed:', err?.response?.data || err?.message);
        setGateOpen(false);
      } finally {
        setIsChecking(false);
      }
    })();
  }, [dispatch, location.pathname]);

  if (isChecking) return <div>Loading...</div>;
  if (!(isAuthenticated || gateOpen)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children || <Outlet />;
};

export default PrivateRoute;
